import { lazy } from "react";
import i18n from "i18next";
import type { DuelModule } from "../types";
import { FALLING_BLOCKS_VERSUS_NS, registerFallingBlocksVersusTranslations } from "./i18n";

registerFallingBlocksVersusTranslations(i18n);

/** Cascade versus (ADR 0077, phase 2). Keyed `falling_blocks_versus`; never "Tetris". */
export const fallingBlocksVersusModule: DuelModule = {
  key: "falling_blocks_versus",
  namespace: FALLING_BLOCKS_VERSUS_NS,
  RealtimeBoard: lazy(() => import("./RealtimeBoard")),
};
